/** Tax invoice ka chhapne wala kagaz.
 *
 *  Dhaancha wahi classic hai jo accountant maangta hai — dispatch khaane,
 *  HSN/QTY/RATE/DISC/GST table, CGST-SGST-IGST block, bank details aur
 *  jurisdiction line. Kaala grid waisa ka waisa, kyunki wahi bill ko
 *  sarkari shakal deta hai.
 *
 *  Type scale print ki unit (pt) me hai, px me nahi — kagaz par wahi size
 *  aata hai jo yahan likha hai. Paanch darje, poore bill me wahi:
 *
 *     7.5pt  label        INVOICE NO. · PACKING · TOTAL ADD (caps)
 *     8.5pt  chhota matn  firm ka pata · terms · bank
 *     9.5pt  bill ka matn party, items, tax, totals
 *      12pt  pehchaan     party ka naam · invoice no · date · gross
 *      17pt  firm         BLUE PEARL
 *
 *  Net Payable (14pt) aur amount in words (11pt) jaan-boojh kar alag hain.
 *  Isse neeche kuch nahi — 7.5pt se chhota kagaz par padha nahi jaata. */

import { FIRM, amountInWords, computeBill, num, stateCodeOf } from "./tax_bill_calc";
import signUrl from "../assets/bill/sign.png";

const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (c) => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]
));
const abs = (u) => new URL(u, window.location.origin).href;

/* MAVIINCI ka asli logo, seedha vector me — BACKUP SEP26/LOGO ki
   "only logo" aur "only name" files se, viewBox kas kar. Bill ke andar hi
   likha hai, koi file load nahi hoti, print me tez aata hai. Pehle wali
   invoice-logo.svg bhoore box me thi — kaale-safed bill par bhaari lagti. */
const LOGO_MARK = `<svg class="mark" viewBox="176 86 476 410" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g fill="#111">
<path d="M271.42,89.36c-57.44,53.74-87.68,125.67-90.12,198.53c-2.43,72.86,22.92,146.65,76.64,204.11l0.3-0.29 v-20.99c-88.19-105.57-82.74-261.7,12.77-360.86l130.08,139.11l9.02-9.02L271.42,89.36z"/>
<path d="M271.15,130.99c-37.59,43.96-59.16,99.46-61.12,157.86c-1.9,57.14,15.09,112.76,48.21,158.55v-26.05 c-23.53-39.54-35.47-85.57-33.9-132.01c1.63-49.34,18.45-97.21,47.67-136.48l108.82,116.38l10.13-10.13L271.15,130.99z"/>
<path d="M273.73,175.66c-21.39,34-33.74,73.92-35.09,114.14c-1.15,34.33,5.71,68.97,19.6,100.36v-45.05 c-4.11-17.94-5.91-36.37-5.3-54.82c1.06-31.56,9.16-62.57,23.59-90.68l84.04,89.88l10.12-10.12L273.73,175.66z"/>
<path d="M647.24,287.89c-2.45-72.86-32.68-144.79-90.12-198.53L417.3,238.83l10.13,10.13l130.09-139.09 c95.51,99.16,100.96,255.29,12.77,360.86v20.99l0.3,0.29C624.32,434.54,649.67,360.75,647.24,287.89z"/>
<path d="M570.3,447.4c33.12-45.79,50.12-101.4,48.21-158.55c-1.96-58.4-23.53-113.9-61.12-157.86L437.57,259.1 l10.13,10.13l108.82-116.38c29.22,39.26,46.04,87.13,47.67,136.48c1.57,46.44-10.36,92.47-33.9,132.01V447.4z"/>
<path d="M570.3,390.17c13.89-31.39,20.74-66.03,19.6-100.36c-1.35-40.22-13.7-80.15-35.09-114.14l-96.98,103.69 l10.12,10.12L552,199.61c14.43,28.11,22.53,59.12,23.59,90.68c0.62,18.45-1.19,36.89-5.3,54.82V390.17z"/>
</g></svg>`;
const LOGO_NAME = `<svg class="word" viewBox="172 416 1576 227" xmlns="http://www.w3.org/2000/svg" aria-label="MAVIINCI"><g fill="#111">
<path d="M283.44,639.44l-73.18-143.82v143.67H175.5l0.17-219.54h34.6l92.05,182.5l91.06-183.7h34.44V639h-34.44V495.62 l-72.02,143.82H283.44z"/>
<path d="M463.41,639.14L582.44,420.5h26.32l118.04,218.8h-38.74l-24.83-46.9l-16.06-29.87l-51.99-93.19l-92.05,169.81H463.41z"/>
<path d="M919.19,420.2h38.74L839.89,639h-26.32L694.53,420.35h39.73l92.05,169.81L919.19,420.2z"/>
<rect x="997.34" y="419.9" width="34.43" height="219.39"/>
<rect x="1101.64" y="419.9" width="34.43" height="219.39"/>
<path d="M1369.18,587.77V419.75h34.6v219.39h-34.93l-137.91-166.22v166.22h-35.76V419.75h32.95L1369.18,587.77z"/>
<path d="M1647.15,451.11h-131.29c-16.56,0.1-24.83,8.27-24.83,24.49v109.47c-0.11,15.23,8.77,22.85,26.65,22.85h129.3l0.17,31.36 l-139.23-0.15c-34.66,0.1-51.99-15.53-51.99-46.9l0.17-125.45c0-31.46,17.27-47.19,51.82-47.19h139.07L1647.15,451.11z"/>
<rect x="1710.06" y="419.9" width="34.44" height="219.39"/>
</g></svg>`;

/** Bill par rupee chinh aur comma nahi — chhape hue bill jaisa saaf number. */
const amt = (v) => {
    const n = num(v);
    if (!n) return "";
    return n % 1 ? n.toFixed(2) : String(Math.round(n));
};
/** 2026-05-15 -> 15-05-26 */
const dmy = (iso) => {
    const s = String(iso || "").slice(0, 10);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}-${m[2]}-${m[1].slice(2)}` : s;
};

/** Item table kam se kam itni lines ka — page bharta hai, ek hi page rehta hai.
 *  PDF print karke naapa: 14 tak ek page; 13 rakha taaki ek wrap hui
 *  description ya note doosre page par na dhakele. */
const MIN_ROWS = 13;

export function billHtml(bill) {
    const t = computeBill(bill);
    const p = bill.party || {};

    const rows = t.lines.map((l, i) => `<tr>
        <td class="c dim n">${i + 1}</td>
        <td class="desc">${esc(l.desc)}</td>
        <td class="c n">${esc(l.hsn)}</td>
        <td class="r n">${l.qty ? `${amt(l.qty)}${l.unit ? ` <span class="unit">${esc(l.unit)}</span>` : ""}` : ""}</td>
        <td class="r n">${amt(l.rate)}</td>
        <td class="c n dim">${num(l.discPct) ? num(l.discPct) : ""}</td>
        <td class="c n dim">${num(l.gstPct) ? num(l.gstPct) : ""}</td>
        <td class="r n amount">${amt(l.base)}</td></tr>`).join("");
    const filler = Array.from({ length: Math.max(0, MIN_ROWS - t.lines.length) },
        () => `<tr class="pad"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>`).join("");

    const taxCell = (side) => t.rateRows.map((g) => {
        const shown = side === "igst" ? g.rate : g.rate / 2;
        const value = side === "cgst" ? g.cgst : side === "sgst" ? g.sgst : g.igst;
        return `<div class="taxline"><span class="pct">${shown}%</span><span class="n">${value ? amt(value) : ""}</span></div>`;
    }).join("");
    const taxTotal = (side) => {
        const v = side === "cgst" ? t.cgst : side === "sgst" ? t.sgst : t.igst;
        return v ? amt(v) : "";
    };
    const taxCol = (side, label) => `<div class="taxcol">
        <div class="taxhead">${label}</div>
        <div class="taxbody">${taxCell(side)}</div>
        <div class="taxfoot"><span>Total</span><span class="n">${taxTotal(side)}</span></div></div>`;

    const money = (label, value, cls = "") =>
        `<tr class="${cls}"><td class="ml">${label}</td><td class="mv n">${value}</td></tr>`;

    const metaPair = (l1, v1, l2, v2) => `
      <tr><td class="lbl">${l1}</td><td class="lbl">${l2}</td></tr>
      <tr><td class="val">${v1}</td><td class="val">${v2}</td></tr>`;

    const box = (label, value, first) =>
        `<td class="box${first ? " first" : ""}"><span class="cap">${label}</span><span class="bv">${value}</span></td>`;

    // Place of supply — GST invoice par state ka naam aur code dono zaroori.
    const posState = p.state || FIRM.state;
    const posCode = stateCodeOf(posState);
    const cancelled = !!bill.cancelled;

    return `<!doctype html><html><head><meta charset="utf-8"/>
<title>Invoice ${esc(bill.no)} — ${esc(p.name)}</title>
<style>
*{box-sizing:border-box}
/* Print dialog me "Background graphics" aksar band hota hai — tab kaali
   patti (TAX INVOICE, NET PAYABLE) aur grey label cells nahi chhapte, aur
   un par likha safed text kaagaz par gum ho kar halka gray dikhta hai.
   Ye browser ko kehta hai ki is bill ke rang hamesha chhaapo. */
*{-webkit-print-color-adjust:exact;print-color-adjust:exact;color-adjust:exact}
html,body{margin:0;padding:0}
body{padding:8mm;background:#e8eaed;color:#111;
  font-family:'Segoe UI','Helvetica Neue',Helvetica,Arial,sans-serif;
  font-size:9.5pt;line-height:1.35;-webkit-font-smoothing:antialiased}
.sheet{width:190mm;margin:0 auto;background:#fff;border:1.2px solid #111;
  box-shadow:0 2px 18px rgba(0,0,0,.14)}
table{border-collapse:collapse;width:100%}
td,th{border:1px solid #111;padding:3px 8px;vertical-align:middle}
.c{text-align:center}
.r{text-align:right;padding-right:10px}
.l{text-align:left}
.b{font-weight:700}
.vt{vertical-align:top}
.n{font-variant-numeric:tabular-nums;font-feature-settings:"tnum"}
.dim{color:#4f555c}
.nb,.nb>tbody>tr>td{border:none}

/* Har label ek hi shakal ka — chhota, caps, faila hua, grey. */
.cap,.lbl,.tag,.kvl,.items thead th,.charges .k,.taxhead,.taxfoot>span:first-child,
.mtbl .ml,.words .lbl,.foot .hd,.juris{
  font-size:7.5pt;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:#4f555c}

/* ── heading band ── */
.band{background:#111;color:#fff;text-align:center;font-size:10pt;font-weight:600;
  letter-spacing:.42em;text-transform:uppercase;padding:5px 0 5px .42em}

/* ── firm + meta ── */
.logo{width:34mm;text-align:center;padding:8px 6px;border-bottom:none}
.logo .lockup{display:flex;flex-direction:column;align-items:center;gap:2.6mm}
.logo .mark{display:block;height:15mm;width:auto}
.logo .word{display:block;width:25mm;height:auto}
.firm{padding:7px 11px;border-bottom:none;vertical-align:top}
.firm .name{font-size:17pt;font-weight:700;letter-spacing:.02em;line-height:1.1}
.firm .rule{height:1.5px;background:#111;width:24mm;margin:4px 0 5px}
.firm .a{font-size:8.5pt;line-height:1.5;color:#33383e}
.firm .gst{font-size:8.5pt;font-weight:700;color:#111}
.meta{height:100%}
.meta td{padding:2px 6px;text-align:center}
.meta .lbl{background:#f2f3f4;white-space:nowrap;padding:3px 6px}
.meta .val{height:20px;font-weight:600}
.meta .big{font-size:12pt;font-weight:700;font-variant-numeric:tabular-nums}

/* ── buyer + dispatch ── */
.tag{background:#f2f3f4;padding:3px 8px}
.pname{font-size:12pt;font-weight:700;letter-spacing:.01em;padding:4px 8px}
.kv td{height:20px}
.kvl{width:15mm}
.box{padding:3px 8px;vertical-align:top}
.box.first{width:50%;border-right:1px solid #111}
.box .cap,.tod .cap{display:block;margin-bottom:1px}
.box .bv{display:block;min-height:15px;font-weight:600}
.tod{padding:4px 8px;height:30px;vertical-align:top}

/* ── items ── */
.items thead th{background:#f2f3f4;padding:5px 8px;color:#2a2f35}
.items tbody tr{height:21px}
.items .desc{font-weight:700}
.items .amount{font-weight:700;font-size:10pt}
/* khaali jagah — ledger jaisi halki lakeerein, soonapan na lage */
.items tr.pad td{border-top:none;border-bottom:1px solid #eceef0}
.items tbody tr:last-child td{border-bottom:1px solid #111}

/* ── charges + tax ── */
.charges td{text-align:center;padding:3px 6px}
.charges .k{display:block}
.charges .v{display:block;min-height:15px;font-weight:700}
.charges .gl{background:#f2f3f4;text-align:right;padding-right:12px;
  font-size:8.5pt;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#2a2f35}
.charges .gv{text-align:right;padding-right:10px;font-size:12pt;font-weight:700}

.taxgrid>tbody>tr>td{padding:0;vertical-align:top}
/* td{height:1px} ka purana nuskha: isse andar ka height:100% kaam karta hai,
   column poori uchaai leta hai aur TOTAL teeno me neeche ek hi line par
   baithta hai — beech me latakta nahi. */
.taxgrid>tbody>tr>td{height:1px}
.taxcol{display:flex;flex-direction:column;height:100%}
.taxhead{text-align:center;background:#f2f3f4;border-bottom:1px solid #111;padding:4px;color:#2a2f35}
.taxbody{flex:1 1 auto;padding:2px 0}
.taxline{display:flex;justify-content:space-between;align-items:baseline;padding:2px 10px 2px 8px}
.taxline .pct{color:#4f555c}
.taxfoot{border-top:1px solid #111;display:flex;justify-content:space-between;align-items:center;
  min-height:24px;padding:3px 10px 3px 8px;font-weight:700;background:#fafbfb}

/* Totals ek nested table hai — apna left/right border nahi banata, warna
   bahar wale cell ke saath double ho kar lakeerein khisak jaati hain. */
.mtbl{width:100%;height:100%}
.mtbl td{border:none;border-bottom:1px solid #111;height:22px}
.mtbl .ml{border-right:1px solid #111;text-align:right;padding-right:10px}
.mtbl .mv{text-align:right;width:44%;font-weight:700;padding-right:10px}
.mtbl tr:last-child td{border-bottom:none}
.mtbl .net td{background:#111;color:#fff;height:30px}
.mtbl .net .ml{color:#fff;font-size:9pt;letter-spacing:.12em}
.mtbl .net .mv{font-size:14pt;padding-right:12px}

/* ── words + footer ── */
.words{padding:5px 9px}
.words .w{font-size:11pt;font-weight:700;padding-top:2px}
.foot td{font-size:8.5pt;line-height:1.55;color:#33383e;padding:5px 9px;vertical-align:top}
.foot .hd{text-align:center;background:#f2f3f4;padding:4px;vertical-align:middle;color:#2a2f35}
.bank b{display:inline-block;width:12mm;color:#111}
.sign{text-align:center;vertical-align:bottom;padding-bottom:3px}
.sign img{height:14mm;display:block;margin:0 auto}
.sign .who{font-size:7.5pt;color:#4f555c}
.juris{text-align:center;letter-spacing:.16em;padding:4px;background:#f2f3f4}
.unit{font-size:7.5pt;font-weight:600;color:#4f555c;letter-spacing:.03em}
.sheet{position:relative}
.void{position:absolute;left:0;right:0;top:42%;text-align:center;pointer-events:none;
  font-size:64pt;font-weight:800;letter-spacing:.12em;color:rgba(196,30,58,.18);
  transform:rotate(-24deg)}

@media print{
  body{background:#fff;padding:0}
  .sheet{width:auto;box-shadow:none}
  @page{size:A4;margin:6mm}
  thead{display:table-header-group}
}
</style></head><body>
<div class="sheet">
${cancelled ? `<div class="void">CANCELLED</div>` : ""}
<table><tr><td class="band">Tax Invoice${cancelled ? " — Cancelled" : ""}</td></tr></table>

<table>
 <tr>
  <td class="logo"><div class="lockup">${LOGO_MARK}${LOGO_NAME}</div></td>
  <td class="firm">
    <div class="name">${esc(FIRM.legalName)}</div>
    <div class="rule"></div>
    <div class="a">${esc(FIRM.address)}</div>
    <div class="a">${esc(FIRM.district)}</div>
    <div class="a">Mob. ${esc(FIRM.mobile)}</div>
    <div class="a">${esc(FIRM.email)}</div>
    <div class="gst">GSTIN ${esc(FIRM.gstin)}</div>
    <div class="a">State ${esc(FIRM.state)} &middot; Code ${esc(FIRM.stateCode)}</div>
  </td>
  <td style="padding:0;width:84mm">
    <table class="meta">
      ${metaPair("Invoice No.", `<span class="big">${esc(bill.no)}</span>`, "Date", `<span class="big">${dmy(bill.date)}</span>`)}
      ${metaPair("Reference No. &amp; date", esc(bill.refNo), "Other references", esc(bill.otherRef))}
      ${metaPair("Buyer's Order No.", esc(bill.buyerOrderNo), "Dated", esc(dmy(bill.buyerOrderDate)))}
      ${metaPair("Dispatch Doc No.", esc(bill.dispatchDocNo), "Delivery Note Date", esc(dmy(bill.deliveryNoteDate)))}
    </table>
  </td>
 </tr>
</table>

<table>
 <tr>
  <td style="width:50%;padding:0" class="vt">
    <table class="kv nb">
      <tr><td class="tag" style="border-bottom:1px solid #111">Buyer (Bill To)</td></tr>
      <tr><td class="pname" style="border-bottom:1px solid #111">${esc(p.name)}</td></tr>
      <tr><td style="border-bottom:1px solid #111">${esc(p.address) || "&nbsp;"}</td></tr>
      <tr><td style="border-bottom:1px solid #111">${esc(p.city) || "&nbsp;"}</td></tr>
      <tr><td style="padding:0;border-bottom:1px solid #111"><table class="nb"><tr>
        <td class="kvl" style="border-right:1px solid #111">Mob.</td><td class="n">${esc(p.mobile)}</td></tr></table></td></tr>
      <tr><td style="padding:0"><table class="nb"><tr>
        <td class="kvl" style="border-right:1px solid #111">GSTIN</td><td class="b n">${esc(p.gstin)}</td></tr></table></td></tr>
    </table>
  </td>
  <td style="width:50%;padding:0" class="vt">
    <table class="nb">
      <tr><td style="padding:0;border-bottom:1px solid #111"><table class="nb"><tr>
        ${box("Dispatched Through", esc(bill.dispatchedThrough), true)}${box("Destination", esc(bill.destination))}
      </tr></table></td></tr>
      <tr><td style="padding:0;border-bottom:1px solid #111"><table class="nb"><tr>
        ${box("Bill of Lading / LR-RR No.", esc(bill.lrNo), true)}${box("Motor Vehicle No.", esc(bill.vehicleNo))}
      </tr></table></td></tr>
      <tr><td style="padding:0;border-bottom:1px solid #111"><table class="nb"><tr>
        ${box("Place of Supply", `${esc(posState)}${posCode ? ` (${posCode})` : ""}`, true)}${box("Reverse Charge", "No")}
      </tr></table></td></tr>
      <tr><td class="tod"><span class="cap">Terms of Delivery</span><div>${esc(bill.termsOfDelivery)}</div></td></tr>
    </table>
  </td>
 </tr>
</table>

<table class="items">
 <thead><tr>
  <th class="c" style="width:10mm">No.</th><th class="l">Description of Goods</th>
  <th class="c" style="width:19mm">HSN/SAC</th><th class="r" style="width:21mm">Qty</th>
  <th class="r" style="width:20mm">Rate</th><th class="c" style="width:15mm">Disc%</th>
  <th class="c" style="width:15mm">GST%</th><th class="r" style="width:27mm">Amount</th>
 </tr></thead>
 <tbody>${rows}${filler}</tbody>
</table>

<table class="charges">
 <tr>
  <td><span class="k">Counter Bill</span><span class="v">${esc(bill.counterBill)}</span></td>
  <td><span class="k">Packing</span><span class="v n">${amt(bill.packing)}</span></td>
  <td><span class="k">Transport</span><span class="v n">${amt(bill.transport)}</span></td>
  <td><span class="k">Add</span><span class="v n">${amt(bill.addAmt)}</span></td>
  <td><span class="k">Misc</span><span class="v n">${amt(bill.misc)}</span></td>
  <td class="gl" style="width:34mm">Gross</td>
  <td class="gv n" style="width:27mm">${amt(t.gross)}</td>
 </tr>
</table>

<table class="taxgrid">
 <tr>
  <td style="width:20%">${taxCol("cgst", "CGST")}</td>
  <td style="width:20%">${taxCol("sgst", "SGST")}</td>
  <td style="width:20%">${taxCol("igst", "IGST")}</td>
  <td style="width:40%">
    <table class="mtbl">
      ${money("Total Add", amt(t.totalAdd))}
      ${money("Total Less", amt(t.totalLess))}
      ${money("Add Tax", amt(t.addTax))}
      ${money("TCS", amt(t.tcs))}
      ${Math.abs(t.roundOff) >= 0.005 ? money("Round Off", `${t.roundOff > 0 ? "+" : "−"} ${amt(Math.abs(t.roundOff))}`) : ""}
      ${money("Net Payable", amt(t.net), "net")}
    </table>
  </td>
 </tr>
</table>

<table><tr><td class="words">
  <div class="lbl">Amount chargeable (in words)</div>
  <div class="w">${esc(amountInWords(t.net))}</div>
</td></tr></table>

<table class="foot">
 <tr>
  <td class="hd" style="width:38%">Terms &amp; Conditions</td>
  <td class="hd" style="width:38%">Bank Details &mdash; ${esc(FIRM.bank.name)}</td>
  <td class="hd" style="width:24%">For ${esc(FIRM.legalName)}</td>
 </tr>
 <tr>
  <td>${FIRM.terms.map((x) => `<div>${esc(x)}</div>`).join("")}${bill.notes ? `<div>${esc(bill.notes)}</div>` : ""}</td>
  <td class="bank">
    <div><b>Name</b> ${esc(FIRM.bank.holder)}</div>
    <div><b>A/C</b> <span class="n">${esc(FIRM.bank.account)}</span></div>
    <div><b>IFSC</b> <span class="n">${esc(FIRM.bank.ifsc)}</span></div>
  </td>
  <td class="sign"><img src="${abs(signUrl)}" alt=""/><div class="who">Authorised Signatory</div></td>
 </tr>
 <tr><td colspan="3" class="juris">Subject to ${esc(FIRM.jurisdiction)} jurisdiction</td></tr>
</table>

</div>
<script>window.onload=function(){window.focus();setTimeout(function(){window.print()},350)}<\/script>
</body></html>`;
}

/** Khaali print window abhi kholo — click ke andar hi. Save ke baad kholte
 *  to browser use popup maan kar rok deta (slow net par khaas kar). */
export function openPrintWindow() {
    const w = window.open("", "_blank", "width=950,height=1100");
    if (!w) {
        alert("Popup blocked — allow popups to open the invoice.");
        return null;
    }
    w.document.write("<p style=\"font:14px sans-serif;padding:24px\">Bill save ho raha hai…</p>");
    return w;
}

/** Pehle se khuli window me bill likho; print dialog apne aap khulega. */
export function writeBillTo(w, bill) {
    if (!w || w.closed) return false;
    w.document.open();
    w.document.write(billHtml(bill));
    w.document.close();
    return true;
}

/** Naye tab me kholo aur print dialog dikhao. */
export function printBill(bill) {
    return writeBillTo(openPrintWindow(), bill);
}
